module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.10228/img/asset-marketplace-themes-1x.png"